import { createAction, props } from '@ngrx/store';
import { MediaConfiguration } from '../../core/models/media-configuration';

export const setMediaConfiguration = createAction(
  '[UI] Set Media Screen Configuration',
  props<{ mediaConfig: MediaConfiguration }>()
);

export const setDeviceOrientation = createAction(
  '[UI] Set Device Orientation',
  props<{ orientation: string }>()
);

export const setDeviceResponsiveSize = createAction(
  '[UI] Set Device Responsive Size',
  props<{ respSize: string }>()
);

export const setDynamicContainerIdToClose = createAction(
  '[UI] Close Dynamic Container',
  props<{ dynamicContainerId: number }>()
);

export const setUserIdle = createAction('[UI] Set User Idle', props<{ isUserIdle: boolean }>());

export const setPortalMode = createAction(
  '[UI] Set Portal Mode',
  props<{ portalMode: number | undefined }>()
);
